import { render } from "./importar-xml-pedido.vue?vue&type=template&id=1f092a81"
import script from "./importar-xml-pedido.vue?vue&type=script&lang=js"
export * from "./importar-xml-pedido.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__